var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.readonly)?[_c('v-card',{staticStyle:{"padding":"20px","margin-left":"30px"},attrs:{"id":("editor-js" + _vm.index)}})]:[_c('div',[_c('div',{attrs:{"id":("editor-js" + _vm.index)}})])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }